import React from 'react';
import { connect } from 'react-redux';
import tagsActions from '../../store/tags/action-creators';
import TagForm from './TagForm';

const TagAdd = (props) => {
  // ----------------------
  // Render
  // ----------------------

  return (
    <TagForm
      isLoading={props.isLoading}
      onSave={props.createTag}
    />
  );
};

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    isLoading: state.tags.isLoading.includes('createTag'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    createTag: formData => dispatch(tagsActions.createTag(formData)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TagAdd);
